import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Grid,
  Paper,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  useMediaQuery,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Box,
  FormHelperText,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { ArrowDropDown, Delete, Edit, Visibility, CheckCircle, Error, Close, Upload, Warning } from "@mui/icons-material";
import Search from "../../../components/common/search/Search";
import Input from "../../../components/common/input/Input";
import axiosInstance from "../../../utils/axios/axiosInstance";
import API from "../../../config/apiconfig";
import { useDispatch, useSelector } from "react-redux";
import { userApiLoader } from "../../../action/loaderActions";
import { toast } from "react-toastify";
import loaderGif from "../../../assets/images/loading.gif";
import { useNavigate } from "react-router-dom";

const Eventstab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Use ref to track if component is mounted (following QuickLinks pattern)
  const isMountedRef = useRef(true);

  // Get user data from Redux state
  const userFromState = useSelector(state => state.user || {});

  // Extract user ID from JWT token if not available in state
  const getUserIdFromToken = () => {
    try {
      const token = userFromState.accessToken;
      if (token) {
        // Decode JWT token (split by . and decode base64)
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.sub; // JWT "sub" field contains user ID
      }
    } catch (error) {
      console.error("Error decoding JWT token:", error);
    }
    return null;
  };

  // Get user ID from state or JWT token
  const currentUserId = userFromState?.UserId ||
    userFromState?.userId ||
    userFromState?.id ||
    getUserIdFromToken();

  console.log("👤 Final Current User ID:", currentUserId);
  const [data, setData] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [selectedDateSort, setSelectedDateSort] = useState("");
  const [settings, setSettings] = useState(false);
  const isLgScreen = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const [isCategory, setCategory] = useState([]);
  const [eventName, setEventName] = useState("");
  const [eventCategory, setEventCategory] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventImage, setEventImage] = useState(null);
  const [eventDuration, setEventDuration] = useState("");
  const [eventId, setEventId] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);

  const [upcomingEvents, setUpcomingEvents] = useState([]);

  // NEW: State variables for upcoming events search, filter, and sort
  const [upcomingSearchQuery, setUpcomingSearchQuery] = useState("");
  const [upcomingSelectedFilter, setUpcomingSelectedFilter] = useState("");
  const [upcomingSelectedDateSort, setUpcomingSelectedDateSort] = useState("");
  const [sortedUpcomingEvents, setSortedUpcomingEvents] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  // DELETE CONFIRMATION DIALOG STATES
  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState({
    open: false,
    event: null
  });

  // Today's date for min attribute
const getTodayString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${month}/${day}/${year}`; // MM/DD/YYYY format
};

const todayString = getTodayString();
  const [eventDate, setEventDate] = useState(() => getTodayString());
  const [eventTime, setEventTime] = useState(() => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  });

  // UPDATED: Form validation states following QuickLinks pattern
  const [validationErrors, setValidationErrors] = useState({});
  const [validationTouched, setValidationTouched] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  // UPDATED: Enhanced validation functions following QuickLinks pattern
  const validateEventName = useCallback((name) => {
    const trimmedName = name?.trim() || '';
    
    if (!trimmedName) {
      return 'Event name is required';
    }
    if (trimmedName.length < 1) {
      return 'Event name must be at least 1 characters long';
    }
    if (trimmedName.length > 100) {
      return 'Event name must not exceed 100 characters';
    }
    if (!/^[a-zA-Z0-9\s\-\_\.\,\!\?\&\(\)]+$/.test(trimmedName)) {
      return 'Event name contains invalid characters';
    }
    return null;
  }, []);

  const validateEventCategory = useCallback((category) => {
    if (!category) {
      return 'Category is required';
    }
    
    const numericId = parseInt(category);
    if (isNaN(numericId) || numericId < 1) {
      return 'Please select a valid category';
    }
    
    if (isCategory.length > 0 && !isCategory.find(cat => cat.id.toString() === category.toString())) {
      return 'Selected category does not exist';
    }
    return null;
  }, [isCategory]);

  const validateEventDate = useCallback((date) => {
  if (!date) {
    return 'Date is required';
  }
  
  // Parse MM/DD/YYYY format
  let selectedDate;
  
  if (date.includes('/')) {
    // Handle MM/DD/YYYY format
    const [month, day, year] = date.split('/');
    selectedDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  } else if (date.includes('-')) {
    // Handle YYYY-MM-DD format (fallback)
    selectedDate = new Date(date);
  } else {
    return 'Invalid date format. Please use MM/DD/YYYY format.';
  }
  
  if (isNaN(selectedDate.getTime())) {
    return 'Invalid date. Please select a valid date.';
  }
  
  // Get today's date for comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);
  
  if (selectedDate < today) {
    return 'Event date cannot be in the past';
  }
  
  // Check if date is too far in the future (e.g., 2 years)
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 2);
  maxDate.setHours(0, 0, 0, 0);
  
  if (selectedDate > maxDate) {
    return 'Event date cannot be more than 2 years in the future';
  }
  
  return null;
}, []);

  // FIXED: Enhanced validateEventTime with proper past time blocking
  const validateEventTime = useCallback((time) => {
  if (!time) {
    return 'Time is required';
  }
  
  // Check if time format is valid
  const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  if (!timeRegex.test(time)) {
    return 'Please enter a valid time format';
  }
  
  // If event is today, check if time is not in the past
  if (eventDate) {
    const selectedDateISO = eventDate; // Should already be in YYYY-MM-DD format
    const todayISO = getTodayString();
    
    // Compare just the date part
    const isToday = selectedDateISO === todayISO;
    
    if (isToday) {
      const [hours, minutes] = time.split(':');
      
      // Create date objects for comparison in the same timezone
      const selectedDateTime = new Date();
      selectedDateTime.setHours(parseInt(hours), parseInt(minutes), 0, 0);
      
      const now = new Date();
      
      if (selectedDateTime <= now) {
        return "You can't schedule events in the past! Please select a future time.";
      }
    }
  }
  
  return null;
}, [eventDate]);

  const validateEventDuration = useCallback((duration) => {
    // Handle both string and number inputs
    const durationValue = duration?.toString()?.trim() || '';
    
    if (!durationValue) {
      return 'Duration is required';
    }
    
    const numericDuration = parseInt(durationValue);
    if (isNaN(numericDuration) || numericDuration < 1) {
      return 'Duration must be a positive number';
    }
    if (numericDuration > 1440) { // 24 hours in minutes
      return 'Duration cannot exceed 24 hours (1440 minutes)';
    }
    
    return null;
  }, []);

  const validateEventDescription = useCallback((description) => {
    const trimmedDescription = description?.trim() || '';
    
    if (!trimmedDescription) {
      return 'Description is required';
    }
    if (trimmedDescription.length < 10) {
      return 'Description must be at least 10 characters long';
    }
    if (trimmedDescription.length > 1000) {
      return 'Description must not exceed 1000 characters';
    }
    return null;
  }, []);

  const validateEventLocation = useCallback((location) => {
    const trimmedLocation = location?.trim() || '';
    
    if (!trimmedLocation) {
      return 'Location is required';
    }
    if (trimmedLocation.length < 3) {
      return 'Location must be at least 3 characters long';
    }
    if (trimmedLocation.length > 200) {
      return 'Location must not exceed 200 characters';
    }
    return null;
  }, []);

  const validateEventImage = useCallback((image) => {
    if (!image) {
      return 'Image is required';
    }
    
    // If it's a string (URL from existing event), it's valid
    if (typeof image === 'string') {
      return null;
    }
    
    // Check file type for new uploads
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(image.type)) {
      return 'Only JPEG, PNG, GIF, and WebP images are allowed';
    }
    
    // Check file size (10MB limit)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (image.size > maxSize) {
      return 'Image size must not exceed 10MB';
    }
    
    // Check minimum size (optional)
    const minSize = 1024; // 1KB minimum
    if (image.size < minSize) {
      return 'Image file appears to be corrupted or too small';
    }
    
    return null;
  }, []);

  // UPDATED: Form validation following QuickLinks pattern
  const validateForm = useCallback((formData = {
    eventName,
    eventCategory,
    eventDate,
    eventTime,
    eventDuration,
    eventDescription,
    eventLocation,
    eventImage
  }) => {
    const errors = {};

    const nameError = validateEventName(formData.eventName);
    if (nameError) errors.eventName = nameError;

    const categoryError = validateEventCategory(formData.eventCategory);
    if (categoryError) errors.eventCategory = categoryError;

    const dateError = validateEventDate(formData.eventDate);
    if (dateError) errors.eventDate = dateError;

    const timeError = validateEventTime(formData.eventTime);
    if (timeError) errors.eventTime = timeError;

    const durationError = validateEventDuration(formData.eventDuration);
    if (durationError) errors.eventDuration = durationError;

    const descriptionError = validateEventDescription(formData.eventDescription);
    if (descriptionError) errors.eventDescription = descriptionError;

    const locationError = validateEventLocation(formData.eventLocation);
    if (locationError) errors.eventLocation = locationError;

    const imageError = validateEventImage(formData.eventImage);
    if (imageError) errors.eventImage = imageError;

    setValidationErrors(errors);
    const isValid = Object.keys(errors).length === 0;
    setIsFormValid(isValid);

    return { isValid, errors };
  }, [
    eventName, eventCategory, eventDate, eventTime, eventDuration, eventDescription, eventLocation, eventImage,
    validateEventName, validateEventCategory, validateEventDate, validateEventTime, validateEventDuration,
    validateEventDescription, validateEventLocation, validateEventImage
  ]);

  const validateField = useCallback((fieldName, value) => {
    let error = null;

    switch (fieldName) {
      case 'eventName':
        error = validateEventName(value);
        break;
      case 'eventCategory':
        error = validateEventCategory(value);
        break;
      case 'eventDate':
        error = validateEventDate(value);
        break;
      case 'eventTime':
        error = validateEventTime(value);
        break;
      case 'eventDuration':
        error = validateEventDuration(value);
        break;
      case 'eventDescription':
        error = validateEventDescription(value);
        break;
      case 'eventLocation':
        error = validateEventLocation(value);
        break;
      case 'eventImage':
        error = validateEventImage(value);
        break;
      default:
        break;
    }

    setValidationErrors(prev => ({
      ...prev,
      [fieldName]: error
    }));

    return error;
  }, [
    validateEventName, validateEventCategory, validateEventDate, validateEventTime, validateEventDuration,
    validateEventDescription, validateEventLocation, validateEventImage
  ]);

  const markFieldAsTouched = useCallback((fieldName) => {
    setValidationTouched(prev => ({
      ...prev,
      [fieldName]: true
    }));
  }, []);

  // UPDATED: Helper functions following QuickLinks pattern
  const getFieldError = useCallback((fieldName) => {
    return validationTouched[fieldName] && validationErrors[fieldName];
  }, [validationTouched, validationErrors]);

  const isFieldValid = useCallback((fieldName) => {
    return validationTouched[fieldName] && !validationErrors[fieldName];
  }, [validationTouched, validationErrors]);

  // UPDATED: Handle input changes with time re-validation on date change
  const handleInputChange = useCallback((field, value) => {
    switch (field) {
      case 'eventName':
        setEventName(value);
        break;
      case 'eventCategory':
        setEventCategory(value);
        break;
      case 'eventDate':
        setEventDate(value);
        // IMPORTANT: Re-validate time immediately when date changes
        if (eventTime) {
          setTimeout(() => {
            validateField('eventTime', eventTime);
          }, 100);
        }
        break;
      case 'eventTime':
        setEventTime(value);
        break;
      case 'eventDuration':
        setEventDuration(value);
        break;
      case 'eventDescription':
        setEventDescription(value);
        break;
      case 'eventLocation':
        setEventLocation(value);
        break;
      case 'eventImage':
        setEventImage(value);
        break;
      default:
        break;
    }

    markFieldAsTouched(field);
    validateField(field, value);
  }, [eventTime, markFieldAsTouched, validateField]);

  // UPDATED: Trigger validation when form values change
  useEffect(() => {
    if (Object.keys(validationTouched).length > 0) {
      validateForm();
    }
  }, [eventName, eventCategory, eventDate, eventTime, eventDuration, eventDescription, eventLocation, eventImage, validateForm, validationTouched]);

// Helper function to convert MM/DD/YYYY to API format
const convertDateForAPI = (mmddyyyyDate) => {
  if (!mmddyyyyDate || !mmddyyyyDate.includes('/')) {
    return mmddyyyyDate;
  }
  
  const [month, day, year] = mmddyyyyDate.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`; // Convert to YYYY-MM-DD for API
};



  // Add new function to apply date sorting logic
  const applySortByDate = (sortValue, dataToSort) => {
    const sortedArray = [...(dataToSort || [])];
    
    sortedArray.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      
      if (sortValue === "newest") {
        return dateB - dateA; // Newest first
      } else if (sortValue === "oldest") {
        return dateA - dateB; // Oldest first
      }
      return 0;
    });
    
    setSortedData(sortedArray);
  };

  // Add new function to handle date sorting
  const handleDateSort = (sortValue) => {
    setSelectedDateSort(sortValue);
    
    // Get current data (either filtered by category or all data)
    const currentData = selectedFilter 
      ? data?.data?.data.filter((item) => item.category === selectedFilter)
      : data.data?.data;
    
    if (!sortValue) {
      setSortedData(currentData);
      return;
    }
    
    applySortByDate(sortValue, currentData);
  };

  // NEW: Function to apply date sorting logic for upcoming events
  const applyUpcomingSortByDate = (sortValue, dataToSort) => {
    const sortedArray = [...(dataToSort || [])];
    
    sortedArray.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      
      if (sortValue === "newest") {
        return dateB - dateA; // Newest first
      } else if (sortValue === "oldest") {
        return dateA - dateB; // Oldest first
      }
      return 0;
    });
    
    setSortedUpcomingEvents(sortedArray);
  };

  // NEW: Function to handle date sorting for upcoming events
  const handleUpcomingDateSort = (sortValue) => {
    setUpcomingSelectedDateSort(sortValue);
    
    // Get current data (either filtered by category or all data)
    const currentData = upcomingSelectedFilter 
      ? upcomingEvents.filter((item) => item.category === upcomingSelectedFilter)
      : upcomingEvents;
    
    if (!sortValue) {
      setSortedUpcomingEvents(currentData);
      return;
    }
    
    applyUpcomingSortByDate(sortValue, currentData);
  };

  // NEW: Function to handle category filter for upcoming events
  const handleUpcomingSort = (filterValue) => {
    setUpcomingSelectedFilter(filterValue);
    if (!filterValue) {
      // Apply date sort if selected, otherwise show original data
      if (upcomingSelectedDateSort) {
        applyUpcomingSortByDate(upcomingSelectedDateSort, upcomingEvents);
      } else {
        setSortedUpcomingEvents(upcomingEvents);
      }
      return;
    }
    const filtered = upcomingEvents.filter(
      (item) => item.category === filterValue
    );
    
    // Apply date sort to filtered data if date sort is selected
    if (upcomingSelectedDateSort) {
      applyUpcomingSortByDate(upcomingSelectedDateSort, filtered);
    } else {
      setSortedUpcomingEvents(filtered);
    }
  };

  // NEW: Function to handle search for upcoming events
  const handleUpcomingSearch = (value) => {
    setUpcomingSearchQuery(value);
    const filteredData =
      upcomingEvents?.filter((row) =>
        Object.values(row).some((val) =>
          String(val).toLowerCase().includes(value.toLowerCase())
        )
      ) || [];
    setSortedUpcomingEvents(filteredData);
  };

  const handleSort = (filterValue) => {
    setSelectedFilter(filterValue);
    if (!filterValue) {
      // Apply date sort if selected, otherwise show original data
      if (selectedDateSort) {
        applySortByDate(selectedDateSort, data.data?.data);
      } else {
        setSortedData(data.data?.data);
      }
      return;
    }
    const filtered = data?.data?.data.filter(
      (item) => item.category === filterValue
    );
    
    // Apply date sort to filtered data if date sort is selected
    if (selectedDateSort) {
      applySortByDate(selectedDateSort, filtered);
    } else {
      setSortedData(filtered);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    const filteredData =
      data?.data?.data?.filter((row) =>
        Object.values(row).some((val) =>
          String(val).toLowerCase().includes(value.toLowerCase())
        )
      ) || [];
    setSortedData(filteredData);
  };

  // Function to check if current user is the event creator
  const isEventCreator = (event) => {
    // Method 1: Check created_by field (PRIMARY) - Now we have user ID from JWT
    if (event.created_by && currentUserId) {
      const isCreatorByField = event.created_by?.toString() === currentUserId?.toString();
      if (isCreatorByField) return true;
    }

    // Method 2: SAFE Fallback - check if people_attending is 0 AND status shows "Created by Me"
    // This protects against responses affecting the creator's view
    const statusText = attendanceStatusMap[event.people_attending] || "Created by Me";
    const isCreatorByStatus = statusText === "Created by Me";

    if (event.people_attending === 0 && isCreatorByStatus) {
      return true;
    }

    return false;
  };

  // Navigation function for View Participants
  const handleViewParticipants = async (event) => {
    try {
      setIsLoading(true);

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_COMMUNITY_API_BASE_URL}v1/events/view`,
        { id: event.id }
      );

      if (response.data.status === 200) {
        const eventData = response.data.data;

        // Navigate to participants page with the API data
        navigate(`/events/${event.id}/participants`, {
          state: {
            eventData: eventData.event,
            eventName: eventData.event.name,
            responseCounts: eventData.response_counts,
            participants: eventData.participants,
            originalEvent: event
          }
        });

        toast.success('Event details loaded successfully');
      }
    } catch (error) {
      console.error('View Event API Error:', error);

      if (error.response?.data?.status === 404) {
        toast.error('Event not found');
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Failed to load event details');
      }

      // Fallback navigation
      navigate(`/events/${event.id}/participants`, {
        state: {
          eventData: event,
          eventName: event.name,
          error: 'Failed to load detailed event information'
        }
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getCategoryList = () => {
    setIsLoading(true);
    axiosInstance
      .get(`${API.USER_MANAGEMENT_API_BASE_URL}${API.COMMUNITY}${API.EVENT}/categories`)
      .then((res) => {
        setCategory(res?.data?.data);
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getEventsList = () => {
    setIsLoading(true);
    axiosInstance
      .post(`${API.USER_MANAGEMENT_API_BASE_URL}${API.COMMUNITY}${API.EVENT}`, {})
      .then((res) => {
        console.log("📊 Events List Response:", res?.data?.data?.data);
        setData(res?.data);
        setSortedData(res?.data?.data?.data);

        // Check if any event has status 0
        const disabledEvent = res?.data?.data?.data?.find(event => event.status === 0);
        if (disabledEvent) {
          toast.warning(`Event "${disabledEvent.name}" is Disabled`, { autoClose: 6000 });
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // FIXED: Improved getUpcomingEvents function
  const getUpcomingEvents = () => {
    setIsLoading(true);

    // Ensure we have a current user ID before making the API call
    if (!currentUserId) {
      console.warn("No current user ID available for upcoming events filter");
      setUpcomingEvents([]);
      setIsLoading(false);
      return;
    }

    axiosInstance
      .post(`${process.env.REACT_APP_COMMUNITY_API_BASE_URL}v1/events/upcoming`, {})
      .then((res) => {
        console.log("📅 Upcoming Events API Response:", res.data);
        const allEvents = res.data?.data?.data || [];
        
        // Filter out events created by current user
        const filteredEvents = allEvents.filter(
          (event) => {
            const eventCreatorId = event.created_by?.toString();
            const currentUserIdString = currentUserId?.toString();
            
            console.log(`Event ${event.id}: created_by=${eventCreatorId}, currentUser=${currentUserIdString}`);
            
            return eventCreatorId !== currentUserIdString;
          }
        );
        
        console.log("📅 Filtered upcoming events:", filteredEvents.length);
        setUpcomingEvents(filteredEvents);
      })
      .catch((err) => {
        console.error("📅 Upcoming Events API Error:", err);
        
        // Better error handling
        let errorMessage = "Failed to load upcoming events";
        if (err.response?.data?.message) {
          errorMessage = err.response.data.message;
        } else if (err.response?.status === 404) {
          errorMessage = "Upcoming events endpoint not found";
        } else if (err.response?.status >= 500) {
          errorMessage = "Server error loading upcoming events";
        }
        
        console.error(errorMessage);
        setUpcomingEvents([]);
        
        // Optional: Show user-friendly error message
        // toast.error(errorMessage);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // FIXED: Updated useEffect with currentUserId dependency
  useEffect(() => {
    getCategoryList();
    getEventsList();
    
    // Only call getUpcomingEvents if we have a current user ID
    if (currentUserId) {
      getUpcomingEvents();
    }
  }, [currentUserId]); // Add currentUserId as dependency

  // NEW: Update sortedUpcomingEvents when upcomingEvents changes
  useEffect(() => {
    setSortedUpcomingEvents(upcomingEvents);
  }, [upcomingEvents]);

  // UPDATED: Clear form function following QuickLinks pattern
  const clearFormAndErrors = useCallback(() => {
    setEventId(null);
    setEventName("");
    setEventCategory("");
    setEventDescription("");
    setEventLocation("");
    setEventImage(null);
    setEventDuration("");
    setEventDate(todayString);
    const now = new Date();
    setEventTime(now.toTimeString().slice(0, 5));
    setValidationErrors({});
    setValidationTouched({});
    setIsFormValid(false);
  }, [todayString]);

  // UPDATED: Handle create event following QuickLinks pattern
  const handleCreateEvent = useCallback(() => {
    if (!isMountedRef.current) return;

    // Mark required fields as touched for validation display
    const requiredFields = ['eventName', 'eventCategory', 'eventDate', 'eventTime', 'eventDuration', 'eventDescription', 'eventLocation', 'eventImage'];
    requiredFields.forEach(field => markFieldAsTouched(field));

    const { isValid, errors } = validateForm();

    if (!isValid) {
      toast.error('Please fix the validation errors before submitting', {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    const [hours, minutes] = eventTime.split(":");
    const dateObj = new Date();
    dateObj.setHours(+hours);
    dateObj.setMinutes(+minutes);
    const formattedTime = dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    dispatch(userApiLoader({ isApiLoader: true }));
    const formData = new FormData();
    formData.append("name", eventName.trim());
    formData.append("description", eventDescription.trim());
    formData.append("date", convertDateForAPI(eventDate));
    formData.append("time", formattedTime);
    formData.append("duration", eventDuration.toString());
    formData.append("location", eventLocation.trim());
    formData.append("category", eventCategory);
    formData.append("image", eventImage);

    axiosInstance
      .post(
        `${API.USER_MANAGEMENT_API_BASE_URL}${API.COMMUNITY}${API.EVENT}/create`,
        formData
      )
      .then((res) => {
        if (!isMountedRef.current) return;

        const createdEvent = res?.data?.data?.[0];
        if (createdEvent) {
          setSortedData((prev) => [createdEvent, ...prev]);
          setData((prev) => ({
            ...prev,
            data: {
              ...prev?.data,
              data: [createdEvent, ...(prev?.data?.data || [])],
            },
          }));
        }

        toast.success(res?.data?.message || "Event Created", {
          position: "top-center",
          autoClose: 3000,
        });
        setSettings(false); // Auto close the slide bar window
        setSelectedFilter("");
        setCurrentPage(0);
        clearFormAndErrors();
      })
      .catch((err) => {
        console.error("Create Event Error:", err);
        
        let errorMessage = 'Failed to create event';
        if (err.response?.data?.message) {
          errorMessage = err.response.data.message;
        } else if (err.response?.data?.errors) {
          if (Array.isArray(err.response.data.errors)) {
            errorMessage = err.response.data.errors.join(', ');
          } else {
            errorMessage = err.response.data.errors;
          }
        }
        
        if (isMountedRef.current) {
          toast.error(errorMessage, {
            position: "top-center",
            autoClose: 5000,
          });
        }
      })
      .finally(() => {
        if (isMountedRef.current) {
          dispatch(userApiLoader({ isApiLoader: false }));
        }
      });
  }, [
    eventName, eventCategory, eventDate, eventTime, eventDuration, eventDescription, eventLocation, eventImage,
    markFieldAsTouched, validateForm, clearFormAndErrors, dispatch
  ]);

  const handleEdit = (event) => {
    const [formattedHour, modifier] = event.time.split(" ");
    let [hours, minutes] = formattedHour.split(":");
    if (modifier === "PM" && hours !== "12") {
      hours = String(+hours + 12);
    }
    if (modifier === "AM" && hours === "12") {
      hours = "00";
    }
    const time24 = `${hours.padStart(2, "0")}:${minutes}`;

    setIsUpdate(true);
    setSettings(true);
    setEventId(event.id);
    setEventName(event.name);
    setEventCategory(event.category);
    setEventDate(event.date);
    setEventTime(time24);
    setEventDuration(event.duration ? event.duration.toString() : "");
    setEventLocation(event.location);
    setEventImage(event.image);
    setEventDescription(event.description);
    
    // UPDATED: Reset validation state following QuickLinks pattern
    setValidationErrors({});
    setValidationTouched({});
    
    // Set form as valid since we're editing existing data
    setTimeout(() => {
      const editFormData = {
        eventName: event.name,
        eventCategory: event.category,
        eventDate: event.date,
        eventTime: time24,
        eventDuration: event.duration ? event.duration.toString() : "",
        eventLocation: event.location,
        eventImage: event.image,
        eventDescription: event.description
      };
      validateForm(editFormData);
    }, 100);
  };

  // COMPLETELY FIXED: handleUpdate function with all issues resolved
  const handleUpdate = useCallback(() => {
    if (!isMountedRef.current || !eventId) {
      console.error("🚫 Update blocked: Component unmounted or no event ID");
      return;
    }

    // Mark required fields as touched for validation display
    const requiredFields = ['eventName', 'eventCategory', 'eventDate', 'eventTime', 'eventDuration', 'eventDescription', 'eventLocation', 'eventImage'];
    requiredFields.forEach(field => markFieldAsTouched(field));

    const { isValid, errors } = validateForm();

    if (!isValid) {
      console.error("🚫 Validation failed:", errors);
      toast.error('Please fix the validation errors before submitting', {
        position: "top-center",
        autoClose: 5000,
      });
      return;
    }

    dispatch(userApiLoader({ isApiLoader: true }));
    
    // Format time consistently
    const formattedTime = new Date(`1970-01-01T${eventTime}:00`).toLocaleTimeString(
      "en-US",
      {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }
    );

    // FIXED: Ensure duration always has a valid value
    const safeDuration = eventDuration && eventDuration.toString().trim() 
      ? eventDuration.toString() 
      : "60"; // Default to 60 minutes if empty

    // Check if uploading new image
    const isNewImageFile = eventImage && typeof eventImage !== 'string' && eventImage.size;
    
    console.log("🔧 UPDATE EVENT DEBUG:", {
      eventId: eventId,
      eventName: eventName,
      eventCategory: eventCategory,
      eventDate: eventDate,
      eventTime: eventTime,
      formattedTime: formattedTime,
      eventDuration: eventDuration,
      safeDuration: safeDuration,
      eventDescription: eventDescription?.substring(0, 50) + "...",
      eventLocation: eventLocation,
      isNewImageFile: isNewImageFile,
      imageType: typeof eventImage,
      imageUrl: typeof eventImage === 'string' ? eventImage?.substring(0, 50) + "..." : 'N/A'
    });
    
    if (isNewImageFile) {
      // SCENARIO 1: New image file upload - use FormData
      const formData = new FormData();
      
      // CRITICAL: Include ALL required fields in exact format API expects
      formData.append("id", String(eventId));
      formData.append("name", String(eventName).trim());
      formData.append("description", String(eventDescription).trim());
      formData.append("date", convertDateForAPI(eventDate));
      formData.append("time", String(formattedTime));
      formData.append("duration", String(safeDuration));
      formData.append("location", String(eventLocation).trim());
      formData.append("category", String(eventCategory));
      formData.append("image", eventImage); // New file

      console.log("🚀 SENDING FORMDATA REQUEST:");
      for (let pair of formData.entries()) {
        console.log(`  ${pair[0]}: ${pair[0] === 'image' ? '[FILE OBJECT]' : pair[1]}`);
      }

      axiosInstance
        .post(
          `${process.env.REACT_APP_COMMUNITY_API_BASE_URL}v1/events/edit`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then((res) => {
          if (!isMountedRef.current) return;
          
          console.log("✅ FORMDATA UPDATE SUCCESS:", res.data);
          
          // Success handling
          setSettings(false);
          getEventsList();
          toast.success(res?.data?.message || 'Event updated successfully', {
            position: "top-center",
            autoClose: 3000,
          });
          setIsUpdate(false);
          clearFormAndErrors();
        })
        .catch((err) => {
          console.error("💥 FORMDATA UPDATE ERROR:", {
            status: err.response?.status,
            statusText: err.response?.statusText,
            data: err.response?.data,
            message: err.message
          });
          
          let errorMessage = 'Failed to update event with new image';
          if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
          } else if (err.response?.status === 500) {
            errorMessage = 'Server error - Invalid data format or missing required fields';
          } else if (err.response?.status === 422) {
            errorMessage = 'Validation error - Please check all fields are filled correctly';
          } else if (err.response?.status === 413) {
            errorMessage = 'Image file too large - Please use a smaller image';
          }
          
          if (isMountedRef.current) {
            toast.error(errorMessage, {
              position: "top-center",
              autoClose: 5000,
            });
          }
        })
        .finally(() => {
          if (isMountedRef.current) {
            dispatch(userApiLoader({ isApiLoader: false }));
          }
        });
    } else {
      // SCENARIO 2: No new image - use JSON with existing image URL
      const updatePayload = {
        id: String(eventId), // CRITICAL: Send as string
        name: String(eventName).trim(),
        description: String(eventDescription).trim(),
        date: convertDateForAPI(eventDate),
        time: String(formattedTime),
        duration: String(safeDuration), // CRITICAL: Always include duration
        location: String(eventLocation).trim(),
        category: String(eventCategory),
        image: String(eventImage || '') // CRITICAL: Always include existing image URL
      };
      
      console.log("🚀 SENDING JSON REQUEST:", JSON.stringify(updatePayload, null, 2));
      
      axiosInstance
        .post(
          `${process.env.REACT_APP_COMMUNITY_API_BASE_URL}v1/events/edit`,
          updatePayload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then((res) => {
          if (!isMountedRef.current) return;
          
          console.log("✅ JSON UPDATE SUCCESS:", res.data);
          
          // Success handling
          setSettings(false);
          getEventsList();
          toast.success(res?.data?.message || 'Event updated successfully', {
            position: "top-center",
            autoClose: 3000,
          });
          setIsUpdate(false);
          clearFormAndErrors();
        })
        .catch((err) => {
          console.error("💥 JSON UPDATE ERROR:", {
            status: err.response?.status,
            statusText: err.response?.statusText,
            data: err.response?.data,
            message: err.message,
            sentPayload: updatePayload
          });
          
          let errorMessage = 'Failed to update event';
          if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
          } else if (err.response?.status === 500) {
            errorMessage = 'Server error - Please verify all required fields are correct';
          } else if (err.response?.status === 422) {
            errorMessage = 'Validation error - Please check field formats';
          } else if (err.response?.status === 404) {
            errorMessage = 'Event not found or you do not have permission to edit';
          }
          
          if (isMountedRef.current) {
            toast.error(errorMessage, {
              position: "top-center",
              autoClose: 5000,
            });
          }
        })
        .finally(() => {
          if (isMountedRef.current) {
            dispatch(userApiLoader({ isApiLoader: false }));
          }
        });
    }
  }, [
    eventId, eventName, eventCategory, eventDate, eventTime, eventDuration, eventDescription, eventLocation, eventImage,
    markFieldAsTouched, validateForm, clearFormAndErrors, dispatch
  ]);

  // HANDLE DELETE EVENT WITH CONFIRMATION DIALOG
  const handleDeleteClick = (event) => {
    setDeleteConfirmDialog({
      open: true,
      event: event
    });
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmDialog({
      open: false,
      event: null
    });
  };

  const handleDeleteConfirm = () => {
    const eventToDelete = deleteConfirmDialog.event;
    if (!eventToDelete) return;

    dispatch(userApiLoader({ isApiLoader: true }));
    axiosInstance
      .delete(
        `${API.USER_MANAGEMENT_API_BASE_URL}${API.COMMUNITY}${API.EVENT}/${eventToDelete.id}`
      )
      .then((res) => {
        getEventsList();
        dispatch(userApiLoader({ isApiLoader: false }));
        toast.success(res?.data?.message, { autoClose: 6000 });
        // Close the dialog
        setDeleteConfirmDialog({
          open: false,
          event: null
        });
      })
      .catch((err) => {
        dispatch(userApiLoader({ isApiLoader: false }));
        toast.error(err?.data?.message, { autoClose: 6000 });
        // Close the dialog even on error
        setDeleteConfirmDialog({
          open: false,
          event: null
        });
      });
  };

  const duplicateEvent = (event) => {
    dispatch(userApiLoader({ isApiLoader: true }));
    axiosInstance
      .post(`/v1/events/duplicate`, { id: event.id })
      .then((res) => {
        const duplicatedEvent = res?.data?.data?.[0];
        if (duplicatedEvent) {
          setSortedData((prevSorted) => [
            ...(prevSorted || []),
            duplicatedEvent,
          ]);
          setData((prevData) => {
            if (!prevData || !prevData.data || !prevData.data.data)
              return prevData;
            return {
              ...prevData,
              data: {
                ...prevData.data,
                data: [...prevData.data.data, duplicatedEvent],
              },
            };
          });
          toast.success(
            res?.data?.message || "Event duplicated successfully"
          );
        } else {
          toast.error("Duplicate response missing event data");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to duplicate event");
      })
      .finally(() => {
        dispatch(userApiLoader({ isApiLoader: false }));
      });
  };

  // FIXED: Improved handleRSVP function
  const handleRSVP = (event, responseValue) => {
    const responseInt = parseInt(responseValue);
    console.log("🎯 RSVP - Event ID:", event.id);
    console.log("🎯 RSVP - Response Value:", responseInt);

    // Validate response value
    if (![1, 2, 3].includes(responseInt)) {
      toast.error("Invalid response value");
      return;
    }

    setIsLoading(true);

    axiosInstance
      .post(`${process.env.REACT_APP_COMMUNITY_API_BASE_URL}v1/events/respond`, {
        id: event.id,
        response: responseInt,
      })
      .then((res) => {
        console.log("✅ RSVP API Response:", res.data);
        
        // Check if response is successful
        if (res.data.status === 200 || res.status === 200) {
          toast.success(res?.data?.message || "RSVP saved successfully!");

          // Remove the event from upcomingEvents list
          setUpcomingEvents((prevEvents) =>
            prevEvents.filter((e) => e.id !== event.id)
          );

          // Add the event to "My Events" with correct attendance status
          const eventForMyList = {
            ...event,
            people_attending: responseInt, // This represents the user's response
            is_attending: responseInt // Also set is_attending for consistency
          };

          // Add to sortedData (My Events)
          setSortedData(prev => [eventForMyList, ...prev]);

          // Add to main data
          setData(prevData => ({
            ...prevData,
            data: {
              ...prevData?.data,
              data: [eventForMyList, ...(prevData?.data?.data || [])]
            }
          }));

          console.log("✅ Event moved to My Events with status:", responseInt);
        } else {
          throw new Error(res?.data?.message || "RSVP failed");
        }
      })
      .catch((err) => {
        console.error("💥 RSVP API Error:", err);
        
        let errorMessage = "Failed to save RSVP";
        if (err.response?.data?.message) {
          errorMessage = err.response.data.message;
        } else if (err.response?.status === 400) {
          errorMessage = "Invalid RSVP request";
        } else if (err.response?.status === 404) {
          errorMessage = "Event not found";
        } else if (err.response?.status >= 500) {
          errorMessage = "Server error saving RSVP";
        }
        
        toast.error(errorMessage);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleStatusChange = async (event, responseValue) => {
    try {
      setIsLoading(true);

      console.log("🚀 Sending API request for event:", event.id);
      console.log("🚀 With response value:", responseValue);

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_COMMUNITY_API_BASE_URL}v1/events/respond`,
        {
          id: event.id,
          response: responseValue
        }
      );

      console.log("✅ API Response:", response.data);

      if (response.data.status === 200 || response.status === 200) {
        if (responseValue === 2) {
          // "No, I'm not attending" - Remove from My Events, add to Upcoming
          console.log("📤 Moving event to upcoming events");

          const updatedSortedEvents = sortedData.filter(e => e.id !== event.id);
          setSortedData(updatedSortedEvents);

          const updatedMainData = {
            ...data,
            data: {
              ...data?.data,
              data: data?.data?.data?.filter(e => e.id !== event.id) || []
            }
          };
          setData(updatedMainData);

          // Add to upcoming events
          const eventForUpcoming = {
            ...event,
            people_attending: 0,
            is_attending: null
          };
          setUpcomingEvents(prev => [eventForUpcoming, ...prev]);

          toast.success("Status updated! Event moved to upcoming events.");
        } else {
          // Update status in current list
          console.log("🔄 Updating event status in current list");

          const updatedSortedEvents = sortedData.map(e => {
            if (e.id === event.id) {
              console.log(`Updating event ${e.id} from ${e.is_attending} to ${responseValue}`);
              return { ...e, is_attending: responseValue };
            }
            return e;
          });

          const updatedMainData = {
            ...data,
            data: {
              ...data?.data,
              data: data?.data?.data?.map(e => {
                if (e.id === event.id) {
                  return { ...e, is_attending: responseValue };
                }
                return e;
              }) || []
            }
          };

          console.log("📊 Updated sortedData:", updatedSortedEvents.find(e => e.id === event.id));

          setSortedData(updatedSortedEvents);
          setData(updatedMainData);

          toast.success("Status updated successfully!");
        }
      } else {
        console.log("❌ API returned non-200 status:", response.data);
        toast.error("Failed to update status");
      }
    } catch (error) {
      console.error("💥 Status change error:", error);
      toast.error("Failed to update status. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const attendanceStatusMap = {
    1: "Yes, Will be Attending",
    2: "May be Attending",
  };

  // Function to get proper status text for the current user
  const getStatusText = (event) => {
    // If current user is the creator, ALWAYS show "Created by Me"
    if (isEventCreator(event)) {
      return "Created by Me";
    }

    // If current user is not the creator, show their attendance status
    return attendanceStatusMap[event.people_attending] || "No Response";
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // FIXED: Added upcoming events dropdown component
  const renderUpcomingEventDropdown = (event) => (
    <select
      className="upcoming-event-select"
      value={event.is_attending?.toString() ?? "0"}
      onChange={(e) => {
        const selectedValue = e.target.value;
        
        // Only allow RSVP if not already responded
        if (selectedValue !== "0") {
          handleRSVP(event, selectedValue);
        }
      }}
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "1px solid #d1d5db",
        backgroundColor: "ccc",
        fontFamily: '"Saira", sans-serif',
        fontSize: "14px",
        cursor: "pointer",
        minWidth: "180px"
      }}
    >
      <option value="0">📝 Respond</option>
      <option value="1">✅ Yes, Will be Attending</option>
      <option value="3">🤔 Maybe Attending</option>
    </select>
  );

  // UPDATED: Enhanced form component following QuickLinks validation pattern
  const renderFormContent = () => (
    <>
      {/* Event Name */}
      <div className="form-group" style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 600,
          color: '#333',
          fontFamily: '"Saira", sans-serif'
        }}>
          Event Name <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder="Enter event name"
            value={eventName}
            onChange={(e) => handleInputChange('eventName', e.target.value)}
            onBlur={() => markFieldAsTouched('eventName')}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: getFieldError('eventName') ? '2px solid #ef4444' : 
                     isFieldValid('eventName') ? '2px solid #10b981' : '1px solid #ddd',
              borderRadius: '8px',
              fontSize: '16px',
              fontFamily: '"Saira", sans-serif',
              backgroundColor: getFieldError('eventName') ? 'rgba(239, 68, 68, 0.05)' :
                              isFieldValid('eventName') ? 'rgba(16, 185, 129, 0.05)' : 'white',
              outline: 'none',
              boxSizing: 'border-box',
              paddingRight: (isFieldValid('eventName') || getFieldError('eventName')) ? '40px' : '16px'
            }}
            onFocus={(e) => {
              if (!getFieldError('eventName')) {
                e.target.style.borderColor = '#ce55b9';
              }
            }}
          />
          {isFieldValid('eventName') && (
            <CheckCircle style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#10b981', 
              fontSize: '20px' 
            }} />
          )}
          {getFieldError('eventName') && (
            <Error style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#ef4444', 
              fontSize: '20px' 
            }} />
          )}
        </div>
        <div style={{
          marginTop: '4px',
          fontSize: '12px',
          color: getFieldError('eventName') ? '#ef4444' : '#666',
          fontFamily: '"Saira", sans-serif'
        }}>
          {getFieldError('eventName') || 'Enter a descriptive name for your event'}
        </div>
      </div>

      {/* Event Category */}
      <div className="form-group" style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 600,
          color: '#333',
          fontFamily: '"Saira", sans-serif'
        }}>
          Event Category <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <FormControl
          fullWidth
          className="!my-2"
          error={!!getFieldError('eventCategory')}
          style={{ position: 'relative' }}
        >
          <Select
            value={eventCategory}
            onChange={(e) => handleInputChange('eventCategory', e.target.value)}
            onBlur={() => markFieldAsTouched('eventCategory')}
            displayEmpty
            disabled={isLoading}
            IconComponent={(props) => (
              <ArrowDropDown
                {...props}
                style={{ color: "#ce55b9" }}
              />
            )}
            style={{
              borderRadius: '8px',
              fontFamily: '"Saira", sans-serif',
              fontSize: '16px',
              border: getFieldError('eventCategory') ? '2px solid #ef4444' : 
                     isFieldValid('eventCategory') ? '2px solid #10b981' : '1px solid #ddd',
              backgroundColor: getFieldError('eventCategory') ? 'rgba(239, 68, 68, 0.05)' :
                              isFieldValid('eventCategory') ? 'rgba(16, 185, 129, 0.05)' : 'white',
            }}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none'
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: 'none'
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                border: 'none'
              }
            }}
          >
            <MenuItem value="" disabled style={{ fontFamily: '"Saira", sans-serif' }}>
              Select a category
            </MenuItem>
            {isCategory.length > 0 &&
              isCategory.map((e, i) => (
                <MenuItem value={e?.id} key={i} style={{ fontFamily: '"Saira", sans-serif' }}>
                  {e?.name}
                </MenuItem>
              ))}
          </Select>
          {isFieldValid('eventCategory') && (
            <CheckCircle style={{ 
              position: 'absolute', 
              right: '40px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#10b981', 
              fontSize: '20px',
              pointerEvents: 'none'
            }} />
          )}
          {getFieldError('eventCategory') && (
            <Error style={{ 
              position: 'absolute', 
              right: '40px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#ef4444', 
              fontSize: '20px',
              pointerEvents: 'none'
            }} />
          )}
        </FormControl>
        <div style={{
          marginTop: '4px',
          fontSize: '12px',
          color: getFieldError('eventCategory') ? '#ef4444' : '#666',
          fontFamily: '"Saira", sans-serif'
        }}>
          {getFieldError('eventCategory') || 'Choose the most appropriate category for your event'}
        </div>
      </div>


{/* Date and Time Row */}
<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
  {/* Event Date */}
  <div className="form-group">
    <label style={{
      display: 'block',
      marginBottom: '8px',
      fontWeight: 600,
      color: '#333',
      fontFamily: '"Saira", sans-serif'
    }}>
      Event Date <span style={{ color: '#ef4444' }}>*</span>
    </label>
    <div style={{ position: 'relative' }}>
      <input
        type="date"
        value={(() => {
          // Convert MM/DD/YYYY to YYYY-MM-DD for date input
          if (eventDate && eventDate.includes('/')) {
            const [month, day, year] = eventDate.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          }
          return eventDate;
        })()}
        min={(() => {
          // Set minimum date to today
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth() + 1).padStart(2, '0');
          const day = String(today.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        })()}
        max={(() => {
          // Set maximum date to 2 years from now
          const maxDate = new Date();
          maxDate.setFullYear(maxDate.getFullYear() + 2);
          const year = maxDate.getFullYear();
          const month = String(maxDate.getMonth() + 1).padStart(2, '0');
          const day = String(maxDate.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        })()}
        onChange={(e) => {
          const selectedDate = e.target.value; // This will be in YYYY-MM-DD format
          if (selectedDate) {
            // Convert YYYY-MM-DD to MM/DD/YYYY for internal state
            const [year, month, day] = selectedDate.split('-');
            const formattedDate = `${month}/${day}/${year}`;
            handleInputChange('eventDate', formattedDate);
          } else {
            handleInputChange('eventDate', '');
          }
        }}
        onBlur={() => markFieldAsTouched('eventDate')}
        disabled={isLoading}
        style={{
          width: '100%',
          padding: '12px 16px',
          border: getFieldError('eventDate') ? '2px solid #ef4444' : 
                 isFieldValid('eventDate') ? '2px solid #10b981' : '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '16px',
          fontFamily: '"Saira", sans-serif',
          outline: 'none',
          backgroundColor: getFieldError('eventDate') ? 'rgba(239, 68, 68, 0.05)' :
                          isFieldValid('eventDate') ? 'rgba(16, 185, 129, 0.05)' : 'white',
          boxSizing: 'border-box',
          paddingRight: (isFieldValid('eventDate') || getFieldError('eventDate')) ? '40px' : '16px',
          cursor: 'pointer'
        }}
        onFocus={(e) => {
          if (!getFieldError('eventDate')) {
            e.target.style.borderColor = '#ce55b9';
          }
        }}
        // Prevent manual text input but allow picker interactions
        onKeyDown={(e) => {
          // Allow navigation keys, space, enter, escape for picker functionality
          const allowedKeys = ['Tab', 'Enter', 'Escape', 'Space', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
          if (!allowedKeys.includes(e.key)) {
            e.preventDefault();
          }
        }}
      />
      {isFieldValid('eventDate') && (
        <CheckCircle style={{ 
          position: 'absolute', 
          right: '12px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          color: '#10b981', 
          fontSize: '20px' 
        }} />
      )}
      {getFieldError('eventDate') && (
        <Error style={{ 
          position: 'absolute', 
          right: '12px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          color: '#ef4444', 
          fontSize: '20px' 
        }} />
      )}
    </div>
    <div style={{
      marginTop: '4px',
      fontSize: '12px',
      color: getFieldError('eventDate') ? '#ef4444' : '#666',
      fontFamily: '"Saira", sans-serif'
    }}>
      {getFieldError('eventDate') || 'Click the calendar icon to open the date picker'}
    </div>
  </div>

  {/* Event Time */}
  <div className="form-group">
    <label style={{
      display: 'block',
      marginBottom: '8px',
      fontWeight: 600,
      color: '#333',
      fontFamily: '"Saira", sans-serif'
    }}>
      Event Time <span style={{ color: '#ef4444' }}>*</span>
    </label>
    <div style={{ position: 'relative' }}>
      <input
        type="time"
        value={eventTime}
        onChange={(e) => handleInputChange('eventTime', e.target.value)}
        onBlur={() => markFieldAsTouched('eventTime')}
        disabled={isLoading}
        style={{
          width: '100%',
          padding: '12px 16px',
          border: getFieldError('eventTime') ? '2px solid #ef4444' : 
                 isFieldValid('eventTime') ? '2px solid #10b981' : '1px solid #ddd',
          borderRadius: '8px',
          fontSize: '16px',
          fontFamily: '"Saira", sans-serif',
          outline: 'none',
          cursor: 'pointer',
          backgroundColor: getFieldError('eventTime') ? 'rgba(239, 68, 68, 0.05)' :
                          isFieldValid('eventTime') ? 'rgba(16, 185, 129, 0.05)' : 'white',
          boxSizing: 'border-box',
          paddingRight: (isFieldValid('eventTime') || getFieldError('eventTime')) ? '40px' : '16px'
        }}
        onFocus={(e) => {
          if (!getFieldError('eventTime')) {
            e.target.style.borderColor = '#ce55b9';
          }
        }}
        // Prevent manual text input but allow picker interactions
        onKeyDown={(e) => {
          // Allow navigation keys, space, enter, escape for picker functionality
          const allowedKeys = ['Tab', 'Enter', 'Escape', 'Space', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
          if (!allowedKeys.includes(e.key)) {
            e.preventDefault();
          }
        }}
      />
      {isFieldValid('eventTime') && (
        <CheckCircle style={{ 
          position: 'absolute', 
          right: '32px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          color: '#10b981', 
          fontSize: '20px' 
        }} />
      )}
      {getFieldError('eventTime') && (
        <Error style={{ 
          position: 'absolute', 
          right: '32px', 
          top: '50%', 
          transform: 'translateY(-50%)', 
          color: '#ef4444', 
          fontSize: '20px' 
        }} />
      )}
    </div>
    <div style={{
      marginTop: '4px',
      fontSize: '12px',
      color: getFieldError('eventTime') ? '#ef4444' : '#666',
      fontFamily: '"Saira", sans-serif'
    }}>
      {getFieldError('eventTime') || 'Click the clock icon to open the time picker'}
    </div>
  </div>
</div>

      {/* Event Duration */}
      <div className="form-group" style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 600,
          color: '#333',
          fontFamily: '"Saira", sans-serif'
        }}>
          Duration (minutes) <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type="number"
            placeholder="Enter duration in minutes"
            value={eventDuration}
            min="1"
            max="1440"
            onChange={(e) => handleInputChange('eventDuration', e.target.value)}
            onBlur={() => markFieldAsTouched('eventDuration')}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: getFieldError('eventDuration') ? '2px solid #ef4444' : 
                     isFieldValid('eventDuration') ? '2px solid #10b981' : '1px solid #ddd',
              borderRadius: '8px',
              fontSize: '16px',
              fontFamily: '"Saira", sans-serif',
              outline: 'none',
              backgroundColor: getFieldError('eventDuration') ? 'rgba(239, 68, 68, 0.05)' :
                              isFieldValid('eventDuration') ? 'rgba(16, 185, 129, 0.05)' : 'white',
              boxSizing: 'border-box',
              paddingRight: (isFieldValid('eventDuration') || getFieldError('eventDuration')) ? '40px' : '16px'
            }}
            onFocus={(e) => {
              if (!getFieldError('eventDuration')) {
                e.target.style.borderColor = '#ce55b9';
              }
            }}
          />
          {isFieldValid('eventDuration') && (
            <CheckCircle style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#10b981', 
              fontSize: '20px' 
            }} />
          )}
          {getFieldError('eventDuration') && (
            <Error style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#ef4444', 
              fontSize: '20px' 
            }} />
          )}
        </div>
        <div style={{
          marginTop: '4px',
          fontSize: '12px',
          color: getFieldError('eventDuration') ? '#ef4444' : '#666',
          fontFamily: '"Saira", sans-serif'
        }}>
          {getFieldError('eventDuration') || 'Enter event duration in minutes (1-1440)'}
        </div>
      </div>

      {/* Event Description */}
      <div className="form-group" style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 600,
          color: '#333',
          fontFamily: '"Saira", sans-serif'
        }}>
          Event Description <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <div style={{ position: 'relative' }}>
          <textarea
            placeholder="Enter event description"
            rows={4}
            value={eventDescription}
            onChange={(e) => handleInputChange('eventDescription', e.target.value)}
            onBlur={() => markFieldAsTouched('eventDescription')}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: getFieldError('eventDescription') ? '2px solid #ef4444' : 
                     isFieldValid('eventDescription') ? '2px solid #10b981' : '1px solid #ddd',
              borderRadius: '8px',
              fontSize: '16px',
              fontFamily: '"Saira", sans-serif',
              outline: 'none',
              resize: 'vertical',
              minHeight: '100px',
              backgroundColor: getFieldError('eventDescription') ? 'rgba(239, 68, 68, 0.05)' :
                              isFieldValid('eventDescription') ? 'rgba(16, 185, 129, 0.05)' : 'white',
              boxSizing: 'border-box',
              paddingRight: (isFieldValid('eventDescription') || getFieldError('eventDescription')) ? '40px' : '16px'
            }}
            onFocus={(e) => {
              if (!getFieldError('eventDescription')) {
                e.target.style.borderColor = '#ce55b9';
              }
            }}
          />
          {isFieldValid('eventDescription') && (
            <CheckCircle style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '12px', 
              color: '#10b981', 
              fontSize: '20px' 
            }} />
          )}
          {getFieldError('eventDescription') && (
            <Error style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '12px', 
              color: '#ef4444', 
              fontSize: '20px' 
            }} />
          )}
        </div>
        <div style={{
          marginTop: '4px',
          fontSize: '12px',
          color: getFieldError('eventDescription') ? '#ef4444' : '#666',
          fontFamily: '"Saira", sans-serif'
        }}>
          {getFieldError('eventDescription') || 'Provide details about your event (10-1000 characters)'}
        </div>
      </div>

      {/* Event Location */}
      <div className="form-group" style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 600,
          color: '#333',
          fontFamily: '"Saira", sans-serif'
        }}>
          Event Location <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            placeholder="Enter event location"
            value={eventLocation}
            onChange={(e) => handleInputChange('eventLocation', e.target.value)}
            onBlur={() => markFieldAsTouched('eventLocation')}
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: getFieldError('eventLocation') ? '2px solid #ef4444' : 
                     isFieldValid('eventLocation') ? '2px solid #10b981' : '1px solid #ddd',
              borderRadius: '8px',
              fontSize: '16px',
              fontFamily: '"Saira", sans-serif',
              outline: 'none',
              backgroundColor: getFieldError('eventLocation') ? 'rgba(239, 68, 68, 0.05)' :
                              isFieldValid('eventLocation') ? 'rgba(16, 185, 129, 0.05)' : 'white',
              boxSizing: 'border-box',
              paddingRight: (isFieldValid('eventLocation') || getFieldError('eventLocation')) ? '40px' : '16px'
            }}
            onFocus={(e) => {
              if (!getFieldError('eventLocation')) {
                e.target.style.borderColor = '#ce55b9';
              }
            }}
          />
          {isFieldValid('eventLocation') && (
            <CheckCircle style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#10b981', 
              fontSize: '20px' 
            }} />
          )}
          {getFieldError('eventLocation') && (
            <Error style={{ 
              position: 'absolute', 
              right: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)', 
              color: '#ef4444', 
              fontSize: '20px' 
            }} />
          )}
        </div>
        <div style={{
          marginTop: '4px',
          fontSize: '12px',
          color: getFieldError('eventLocation') ? '#ef4444' : '#666',
          fontFamily: '"Saira", sans-serif'
        }}>
          {getFieldError('eventLocation') || 'Specify where the event will take place'}
        </div>
      </div>

      {/* Event Image */}
      <div className="form-group" style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          fontWeight: 600,
          color: '#333',
          fontFamily: '"Saira", sans-serif'
        }}>
          Event Image <span style={{ color: '#ef4444' }}>*</span>
        </label>
        <div style={{ position: 'relative' }}>
          <div
            style={{
              border: getFieldError('eventImage') ? '2px dashed #ef4444' : 
                     isFieldValid('eventImage') ? '2px dashed #10b981' : '2px dashed #ddd',
              borderRadius: '8px',
              padding: '24px',
              textAlign: 'center',
              backgroundColor: getFieldError('eventImage') ? 'rgba(239, 68, 68, 0.05)' :
                              isFieldValid('eventImage') ? 'rgba(16, 185, 129, 0.05)' : '#fafafa',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease'
            }}
            onClick={() => !isLoading && document.getElementById('event-image-input').click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              if (!isLoading) {
                const files = e.dataTransfer.files;
                if (files.length > 0) {
                  handleInputChange('eventImage', files[0]);
                }
              }
            }}
          >
            <input
              id="event-image-input"
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  handleInputChange('eventImage', file);
                }
              }}
              onBlur={() => markFieldAsTouched('eventImage')}
              disabled={isLoading}
              style={{ display: 'none' }}
            />
            
            {/* Show current image preview if editing and image exists */}
            {isUpdate && eventImage && typeof eventImage === 'string' ? (
              <div>
                <img 
                  src={eventImage} 
                  alt="Current event image" 
                  style={{
                    maxWidth: '200px',
                    maxHeight: '150px',
                    borderRadius: '8px',
                    marginBottom: '12px',
                    objectFit: 'cover'
                  }}
                />
                <Typography style={{ fontFamily: '"Saira", sans-serif', fontSize: '14px', color: '#374151', marginBottom: '4px' }}>
                  Current Image - Click to change
                </Typography>
              </div>
            ) : eventImage && typeof eventImage !== 'string' ? (
              // Show new file selected
              <div>
                <Upload style={{ fontSize: '48px', color: '#10b981', marginBottom: '8px' }} />
                <Typography style={{ fontFamily: '"Saira", sans-serif', fontSize: '14px', color: '#374151', marginBottom: '4px' }}>
                  New image selected: {eventImage.name}
                </Typography>
              </div>
            ) : (
              // Show upload prompt
              <div>
                <Upload style={{ fontSize: '48px', color: '#9ca3af', marginBottom: '8px' }} />
                <Typography style={{ fontFamily: '"Saira", sans-serif', fontSize: '14px', color: '#374151', marginBottom: '4px' }}>
                  Click to upload or drag & drop
                </Typography>
              </div>
            )}
            
            <Typography style={{ fontFamily: '"Saira", sans-serif', fontSize: '12px', color: '#6b7280' }}>
              PNG, JPG, GIF, WebP up to 10MB
            </Typography>
            {isFieldValid('eventImage') && (
              <CheckCircle style={{ 
                position: 'absolute', 
                right: '12px', 
                top: '12px', 
                color: '#10b981', 
                fontSize: '24px' 
              }} />
            )}
            {getFieldError('eventImage') && (
              <Error style={{ 
                position: 'absolute', 
                right: '12px', 
                top: '12px', 
                color: '#ef4444', 
                fontSize: '24px' 
              }} />
            )}
          </div>
        </div>
        <div style={{
          marginTop: '4px',
          fontSize: '12px',
          color: getFieldError('eventImage') ? '#ef4444' : '#666',
          fontFamily: '"Saira", sans-serif'
        }}>
          {getFieldError('eventImage') || 'Upload an attractive image for your event'}
        </div>
      </div>
    </>
  );

  // UPDATED: Cleanup effect following QuickLinks pattern
  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return (
    <Grid container spacing={2}>
      <div className="container">
        <div className="css-11ezll3-MuiToolbar-root breadcrumbs">
          <div className="top-sec">
            <div className="card custom-card">
              <div className="card-body ">
                {/* main pannel */}
                <div className="d-flex align-items-center justify-content-between flex-wrap pb-1">
                  <div className="d-flex align-items-center">
                    <h3 className="mb-2">My Event List</h3>
                  </div>
                  <div className="d-flex align-items-center flex-wrap mb-1">
                    <Button variant="contained" color="primary" className="!w-fit !px-3 !h-10" onClick={() => {
                      setSettings(true); clearFormAndErrors();
                    }}>
                      + Add New Event
                    </Button>
                  </div>
                </div>

                <div className="row filter-panel mt-4">
                  <div className="col-md-4">
                    <div className="serarch-bar">
                      <Search
                        value={searchQuery}
                        handleInputChange={(e) => handleSearch(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-4"></div>
                  <div className="col-md-2">
                    <div className="w-full flex items-center justify-end gap-2">
                      <FormControl fullWidth className="filter">
                        <InputLabel style={{ lineHeight: "14px" }}>
                          Sort by Date
                        </InputLabel>
                        <Select
                          value={selectedDateSort}
                          onChange={(e) => handleDateSort(e.target.value)}
                          label="Sort by Date"
                          IconComponent={(props) => (
                            <ArrowDropDown
                              {...props}
                              style={{ color: "#c942b1" }}
                            />
                          )}
                          style={{ height: 40 }}
                        >
                          <MenuItem value="">None</MenuItem>
                          <MenuItem value="newest">Newest First</MenuItem>
                          <MenuItem value="oldest">Oldest First</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="w-full flex items-center justify-end gap-2">
                      <FormControl fullWidth className="filter">
                        <InputLabel style={{ lineHeight: "14px" }}>
                          Filter
                        </InputLabel>
                        <Select
                          value={selectedFilter}
                          onChange={(e) => handleSort(e.target.value)}
                          label="Filter"
                          IconComponent={(props) => (
                            <ArrowDropDown
                              {...props}
                              style={{ color: "#c942b1" }}
                            />
                          )}
                          style={{ height: 40 }}
                        >
                          <MenuItem value="">None</MenuItem>
                          {isCategory.length > 1 &&
                            isCategory.map((e, i) => (
                              <MenuItem value={e?.id} key={i}>
                                {e?.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive mb-0">

                      {isLoading ? (
                        <div className="w-full flex justify-center items-center py-10">
                          <img src={loaderGif} alt="Loading..." className="loading-icon-img" />
                        </div>
                      ) : (
                        <TableContainer className="table table-hover table-bordered mb-0 text-md-nowrap text-lg-nowrap text-xl-nowrap table-striped">
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>S.No</TableCell>
                                <TableCell>Image</TableCell>
                                <TableCell>Event Title</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Time</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Location</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {sortedData.length > 0 ? (
                                sortedData
                                  .slice(
                                    currentPage * rowsPerPage,
                                    currentPage * rowsPerPage + rowsPerPage
                                  )
                                  .map((event, idx) => (
                                    <TableRow
                                      key={idx}
                                      className={event.status === 0 ? "disabled-row" : ""}
                                    >
                                      <TableCell>{currentPage * rowsPerPage + idx + 1}</TableCell>
                                      <TableCell>
                                        <img
                                          src={event.image}
                                          alt={event.name}
                                          className="w-[100px] h-[70px] rounded-md"
                                        />
                                      </TableCell>
                                      <TableCell>{event.name}
                                        {event.status === 0 && (
                                          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                            This event is disabled by admin
                                          </div>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                          {isCategory.find((cat) => cat.id.toString() === event.category.toString())?.name || "N/A"}
                                      </TableCell>
                                      <TableCell>{event.date}</TableCell>
                                      <TableCell>{event.time}</TableCell>
                                      <TableCell>{event.duration ? `${event.duration} min` : "N/A"}</TableCell>
                                      <TableCell>{event.description}</TableCell>
                                      <TableCell>{event.location}</TableCell>
                                      <TableCell>
                                        {isEventCreator(event) ? (
                                          // Show non-editable status for event creators
                                          <span className="font-medium text-blue-600">
                                            Created by Me
                                          </span>
                                        ) : (
                                          // Show dropdown for event participants
                                          <FormControl size="small" sx={{ minWidth: 160 }}>
                                            <Select
                                              value={(() => {
                                                const attending = event.is_attending;
                                                console.log(`Event ${event.id} is_attending:`, attending, typeof attending);

                                                // Convert to number and handle all cases
                                                const numValue = parseInt(attending);

                                                if (numValue === 1) return 1;  // Yes, Will Attend
                                                if (numValue === 2) return 2;  // No, I'm not attending  
                                                if (numValue === 3) return 3;  // Maybe Attending
                                                return 1; // Default to "Yes, Will Attend"
                                              })()}
                                              onChange={(e) => {
                                                const selectedValue = parseInt(e.target.value);
                                                console.log("🎯 Selected dropdown value:", selectedValue);
                                                console.log("🎯 Event before update:", event);
                                                handleStatusChange(event, selectedValue);
                                              }}
                                              sx={{ fontSize: '0.875rem' }}
                                            >
                                              <MenuItem value={1}>
                                                <span className="flex items-center gap-2">
                                                  ✅ Yes, Will Attend
                                                </span>
                                              </MenuItem>
                                              <MenuItem value={3}>
                                                <span className="flex items-center gap-2">
                                                  🤔 Maybe Attending
                                                </span>
                                              </MenuItem>
                                              <MenuItem value={2}>
                                                <span className="flex items-center gap-2">
                                                  ❌ No, I'm not attending
                                                </span>
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {isEventCreator(event) && (
                                          <div className="flex items-center gap-1 active-btn">
                                            {/* View Button - Only for Event Creators */}
                                            <div
                                              onClick={() => handleViewParticipants(event)}
                                              className="btn btn-success btn-icon"
                                              title="View Participants"
                                              style={{ cursor: 'pointer' }}
                                            >
                                              {/* Fixed Eye Icon - Removed namespace attributes */}
                                               <Visibility  color="primary" fontSize="small" />
                                            </div>

                                            {/* Edit Button - Only for Event Creators */}
                                            <div
                                              onClick={() => handleEdit(event)}
                                              className="btn btn-indigo btn-icon"
                                              title="Edit Event"
                                            >
                                              <Edit color="primary" fontSize="small" />
                                            </div>

                                            {/* Delete Button - Only for Event Creators with Confirmation */}
                                            <div
                                              onClick={() => handleDeleteClick(event)}
                                              className="btn btn-denger btn-icon"
                                              title="Delete Event"
                                            >
                                              <Delete color="primary" fontSize="small" />
                                            </div>
                                          </div>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ))
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={11}>
                                    <p className="p-4 text-center text-gray-400">
                                      No Events found
                                    </p>
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                          <TablePagination
                            component="div"
                            count={sortedData.length}
                            page={currentPage}
                            onPageChange={(e, newPage) => setCurrentPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) => {
                              setRowsPerPage(parseInt(e.target.value, 10));
                              setCurrentPage(0);
                            }}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                          />
                        </TableContainer>
                      )}
                    </div>
                  </div>
                </div>
                {/* main pannel */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ENHANCED: Updated upcoming events section with search, filter, and sort */}
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="css-11ezll3-MuiToolbar-root breadcrumbs">
              <div className="top-sec">
                <div className="card custom-card">
                  <div className="card-body">
                    {/* main pannel */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap pb-1">
                      <div className="d-flex align-items-center">
                        <h3 className="mt-2">Upcoming Events List</h3>
                      </div>
                      {upcomingEvents.length > 0 && (
                        <div className="text-sm text-gray-500">
                          {sortedUpcomingEvents.length} of {upcomingEvents.length} event(s) shown
                        </div>
                      )}
                    </div>

                    {/* NEW: Filter panel for upcoming events */}
                    {upcomingEvents.length > 0 && (
                      <div className="row filter-panel mt-4">
                        <div className="col-md-4">
                          <div className="serarch-bar">
                            <Search
                              value={upcomingSearchQuery}
                              handleInputChange={(e) => handleUpcomingSearch(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-4"></div>
                        <div className="col-md-2">
                          <div className="w-full flex items-center justify-end gap-2">
                            <FormControl fullWidth className="filter">
                              <InputLabel style={{ lineHeight: "14px" }}>
                                Sort by Date
                              </InputLabel>
                              <Select
                                value={upcomingSelectedDateSort}
                                onChange={(e) => handleUpcomingDateSort(e.target.value)}
                                label="Sort by Date"
                                IconComponent={(props) => (
                                  <ArrowDropDown
                                    {...props}
                                    style={{ color: "#c942b1" }}
                                  />
                                )}
                                style={{ height: 40 }}
                              >
                                <MenuItem value="">None</MenuItem>
                                <MenuItem value="newest">Newest First</MenuItem>
                                <MenuItem value="oldest">Oldest First</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="w-full flex items-center justify-end gap-2">
                            <FormControl fullWidth className="filter">
                              <InputLabel style={{ lineHeight: "14px" }}>
                                Filter
                              </InputLabel>
                              <Select
                                value={upcomingSelectedFilter}
                                onChange={(e) => handleUpcomingSort(e.target.value)}
                                label="Filter"
                                IconComponent={(props) => (
                                  <ArrowDropDown
                                    {...props}
                                    style={{ color: "#c942b1" }}
                                  />
                                )}
                                style={{ height: 40 }}
                              >
                                <MenuItem value="">None</MenuItem>
                                {isCategory.length > 1 &&
                                  isCategory.map((e, i) => (
                                    <MenuItem value={e?.id} key={i}>
                                      {e?.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* UPDATED: Events display logic with created_by details */}
                    {isLoading ? (
                      <div className="w-full flex justify-center items-center py-10">
                        <img src={loaderGif} alt="Loading..." className="loading-icon-img" />
                        <span className="ml-2">Loading upcoming events...</span>
                      </div>
                    ) : sortedUpcomingEvents.length > 0 ? (
                      sortedUpcomingEvents.map((event, idx) => (
                        <div key={event.id || idx} className="col-md-12">
                          <div className="upcoming-event-list">
                            <div className="row">
                              <div className="col-md-2">
                                <div className="image-show">
                                  <img
                                    src={event.image}
                                    alt={event.name}
                                    onError={(e) => {
                                      e.target.src = "/default-event-image.png"; // Fallback image
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-10">
                                <div className="content-area">
                                  <ul>
                                    <li>
                                      {/* Fixed Calendar Icon - Removed namespace attributes */}
                                      <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" className="h-6 w-6">
                                        <defs>
                                          <style type="text/css">{`
                                            .cls-1 { fill: #fff; }
                                            .cls-2 { fill: #1394f6; }
                                          `}</style>
                                        </defs>
                                        <title />
                                        <g data-name="filled outline" id="filled_outline">
                                          <rect
                                            className="cls-1"
                                            height="50"
                                            rx="5"
                                            transform="translate(66.5 2.5) rotate(90)"
                                            width="41"
                                            x="11.5"
                                            y="9.5"
                                          />
                                          <path
                                            className="cls-2"
                                            d="M7,24V19a5,5,0,0,1,5-5H52a5,5,0,0,1,5,5v5Z"
                                          />
                                          <path
                                            className="cls-1"
                                            d="M20,19a2,2,0,0,1-2-2V11a2,2,0,0,1,4,0v6A2,2,0,0,1,20,19Z"
                                          />
                                          <path
                                            className="cls-1"
                                            d="M44,19a2,2,0,0,1-2-2V11a2,2,0,0,1,4,0v6A2,2,0,0,1,44,19Z"
                                          />
                                          <path
                                            d="M52,13H47V11a3,3,0,0,0-6,0v2H23V11a3,3,0,0,0-6,0v2H12a6,6,0,0,0-6,6V50a6,6,0,0,0,6,6H52a6,6,0,0,0,6-6V19A6,6,0,0,0,52,13Zm-9-2a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0ZM19,11a1,1,0,0,1,2,0v6a1,1,0,0,1-2,0Zm-7,4h5v2a3,3,0,0,0,6,0V15H41v2a3,3,0,0,0,6,0V15h5a4,4,0,0,1,4,4v5H8V19A4,4,0,0,1,12,15ZM52,54H12a4,4,0,0,1-4-4V26H56V50A4,4,0,0,1,52,54ZM20,32v4H16V32h4m2-2H14v8h8V30ZM20,44v4H16V44h4m2-2H14v8h8V42Zm28-7H26V33H50Zm0,12H26V45H50Z"
                                            fill="#000"
                                          />
                                        </g>
                                      </svg>
                                      {event.date}
                                    </li>
                                    <li>
                                      {/* Fixed Clock Icon - Removed namespace attributes */}
                                      <svg
                                        viewBox="0 0 64 64"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                      >
                                        <g data-name="filled outline" id="filled_outline">
                                          <path
                                            fill="#1394f6"
                                            d="M41.61,13.79a8.19,8.19,0,0,1,11.5,11.5Z"
                                          />
                                          <path
                                            fill="#1394f6"
                                            d="M10.89,25.29a8.19,8.19,0,0,1,11.5-11.5Z"
                                          />
                                          <circle fill="#1394f6" cx="32" cy="34" r="17" />
                                          <circle
                                            fill="#fff"
                                            cx="32"
                                            cy="34"
                                            r="13"
                                            transform="translate(-2.05 65.95) rotate(-89.92)"
                                          />
                                          <polygon
                                            fill="currentColor"
                                            points="39.29 42.71 31 34.41 31 26 33 26 33 33.59 40.71 41.29 39.29 42.71"
                                          />
                                          <path
                                            fill="currentColor"
                                            d="M17.35,11.06a9.19,9.19,0,0,0-6.5,15.69l13-13A9.19,9.19,0,0,0,17.35,11.06Zm-5.09,4.1A7.22,7.22,0,0,1,20.82,14l-9.77,9.77A7.21,7.21,0,0,1,12.26,15.16Z"
                                          />
                                          <path
                                            fill="currentColor"
                                            d="M53.15,13.75a9.2,9.2,0,0,0-13,0l13,13A9.19,9.19,0,0,0,53.15,13.75Zm-.2,10L43.18,14A7.19,7.19,0,0,1,53,23.72Z"
                                          />
                                          <path
                                            fill="currentColor"
                                            d="M50,34A18,18,0,0,0,33,16.05V11h3V9H28v2h3v5.05a18,18,0,0,0-8.42,33.27l-3.41,5.13,1.66,1.1,3.52-5.27a17.87,17.87,0,0,0,15.3,0l3.52,5.27,1.66-1.1-3.41-5.13A18,18,0,0,0,50,34ZM32,50A16,16,0,1,1,48,34,16,16,0,0,1,32,50Z"
                                          />
                                        </g>
                                      </svg>
                                      {event.time}
                                    </li>
                                    <li><strong>Category:</strong> {isCategory.find((cat) => cat.id.toString() === event.category.toString())?.name || "N/A"}</li>
                                    <li><strong>Duration:</strong> {event.duration ? `${event.duration} minutes` : "Not specified"}</li>
                                    <li><strong>Location:</strong> {event.location}</li>
                                    <li><strong>Attendees:</strong> {event.people_attending || 0}</li>
                                    {/* UPDATED: Add Created By details with student_name */}
                                    
                                    <li>
                                      <strong>Email:</strong> {event.student?.email || 'Not available'}
                                    </li>
                                    <li>
                                      <strong>Created by:</strong> {event.student?.name || 'Unknown'}
                                    </li>
                                  </ul>

                                  <h2>{event.name}</h2>
                                  <p>{event.description}</p>
                                  
                                  {/* FIXED: Replace the old select with the new dropdown component */}
                                  {renderUpcomingEventDropdown(event)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : upcomingEvents.length > 0 ? (
                      <div className="text-center py-8">
                        <p className="text-gray-500 text-lg">
                          No events match your search or filter criteria
                        </p>
                        <p className="text-gray-400 text-sm mt-2">
                          Try adjusting your search terms or filters
                        </p>
                      </div>
                    ) : (
                      <div className="text-center py-8">
                        <p className="text-gray-500 text-lg">
                          No upcoming events found
                        </p>
                        <p className="text-gray-400 text-sm mt-2">
                          Check back later for new events from other users
                        </p>
                      </div>
                    )}
                    {/* main pannel */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*upcoming */}

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="event-list">
            </div>
          </div>
        </div>
        {/* Upcoming Events Section */}
      </div>

      {/* DELETE CONFIRMATION DIALOG */}
      <Dialog
        open={deleteConfirmDialog.open}
        onClose={handleDeleteCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '8px'
          }
        }}
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          pb: 1,
          fontFamily: '"Saira", sans-serif',
          fontSize: '20px',
          fontWeight: 600
        }}>
          <Warning sx={{ color: '#f59e0b', fontSize: 28 }} />
          Confirm Delete Event
        </DialogTitle>
        
        <DialogContent sx={{ pt: 1 }}>
          <DialogContentText sx={{ 
            fontFamily: '"Saira", sans-serif',
            fontSize: '16px',
            color: '#374151',
            mb: 2
          }}>
            Are you sure you want to delete the event <strong>"{deleteConfirmDialog.event?.name}"</strong>?
          </DialogContentText>
          
          <Box sx={{
            backgroundColor: '#fef3c7',
            border: '1px solid #f59e0b',
            borderRadius: '8px',
            p: 2,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1
          }}>
            <Warning sx={{ color: '#f59e0b', fontSize: 20, mt: 0.2 }} />
            <Box>
              <Typography sx={{ 
                fontFamily: '"Saira", sans-serif',
                fontSize: '14px',
                fontWeight: 600,
                color: '#92400e',
                mb: 0.5
              }}>
                Warning: This action cannot be undone
              </Typography>
              <Typography sx={{ 
                fontFamily: '"Saira", sans-serif',
                fontSize: '13px',
                color: '#92400e'
              }}>
                All event data, participants, and related information will be permanently removed.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        
        <DialogActions sx={{ 
          p: 3, 
          pt: 2,
          gap: 2,
          justifyContent: 'flex-end'
        }}>
          <Button
            onClick={handleDeleteCancel}
            variant="outlined"
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontFamily: '"Saira", sans-serif',
              px: 3,
              py: 1,
              borderColor: '#e5e7eb',
              color: '#6b7280',
              '&:hover': {
                borderColor: '#d1d5db',
                backgroundColor: '#f9fafb'
              }
            }}
          >
            Cancel
          </Button>
          
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontFamily: '"Saira", sans-serif',
              px: 3,
              py: 1,
              backgroundColor: '#dc2626',
              '&:hover': {
                backgroundColor: '#b91c1c'
              }
            }}
            startIcon={<Delete />}
          >
            Delete Event
          </Button>
        </DialogActions>
      </Dialog>

      {/* Form Modal - Updated to match Volunteeroppertunity UI Design */}
      {settings && (
        <div style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: '450px',
          maxWidth: '90vw',
          backgroundColor: 'white',
          boxShadow: '-4px 0 20px rgba(0,0,0,0.1)',
          zIndex: 1300,
          display: 'flex',
          flexDirection: 'column',
          fontFamily: '"Saira", sans-serif'
        }}>
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <div style={{
              background: '#ce55b9',
              color: 'white',
              padding: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <h5 style={{ 
                  fontSize: '20px', 
                  fontWeight: 600, 
                  fontFamily: '"Saira", sans-serif',
                  margin: 0
                }}>
                  {isUpdate ? 'Edit Event' : 'Add New Event'}
                </h5>
              </div>
              <button
                onClick={() => {
                  setIsUpdate(false);
                  setSettings(false);
                  clearFormAndErrors();
                }}
                disabled={isLoading}
                style={{
                  color: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  border: 'none',
                  borderRadius: '6px',
                  width: '32px',
                  height: '32px',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  fontSize: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: isLoading ? 0.6 : 1
                }}
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div style={{
              flex: 1,
              padding: '24px',
              overflow: 'auto',
              background: '#ffffff'
            }}>
              {renderFormContent()}
            </div>

            {/* Footer Actions */}
            <div style={{
              padding: '24px',
              borderTop: '1px solid rgba(0,0,0,0.1)',
              background: 'white',
              display: 'flex',
              gap: '16px',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => {
                  setIsUpdate(false);
                  setSettings(false);
                  clearFormAndErrors();
                }}
                disabled={isLoading}
                style={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontFamily: '"Saira", sans-serif',
                  padding: '12px 24px',
                  minWidth: '100px',
                  backgroundColor: 'transparent',
                  color: '#666',
                  border: '1px solid #ddd',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  opacity: isLoading ? 0.6 : 1
                }}
              >
                Cancel
              </button>
              <button
                onClick={isUpdate ? handleUpdate : handleCreateEvent}
                disabled={!isFormValid || isLoading}
                style={{
                  background: '#ce55b9',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontFamily: '"Saira", sans-serif',
                  padding: '12px 24px',
                  minWidth: '140px',
                  color: 'white',
                  border: 'none',
                  cursor: (!isFormValid || isLoading) ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: (!isFormValid || isLoading) ? 0.6 : 1
                }}
              >
                {isLoading ? (
                  <>
                    <div style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid transparent',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    <span style={{ fontFamily: '"Saira", sans-serif' }}>
                      {isUpdate ? 'Updating...' : 'Creating...'}
                    </span>
                  </>
                ) : (
                  <span style={{ fontFamily: '"Saira", sans-serif' }}>
                    {isUpdate ? 'Update Event' : 'Add Event'}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Overlay */}
      {settings && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1200
          }}
          onClick={() => {
            setIsUpdate(false);
            setSettings(false);
            clearFormAndErrors();
          }}
        />
      )}

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </Grid>
  );
};

export default Eventstab;